/*
 * Copyright (c) 2023 | All Rights Reserved
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *  Written by MeeCode by Mario Murrent
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nextPlugin } from 'translation-check';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import de from './locales/de.json';
import { Logger } from '../core/logger/Logger';

export const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
};

const langDetectorOptions = {
  order: ['cookie', 'localStorage', 'navigator'],

  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'],

  checkWhitelist: true
};

export const initTranslations = async (): Promise<void> => {
  // Translations are bundled from `./locales/*.json` (kept current by
  // `yarn gen:i18n`) and used directly via `resources` — no runtime fetch.
  await i18n
    .use(i18nextPlugin)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      lng: 'de',
      fallbackLng: 'de',
      keySeparator: '.',
      detection: langDetectorOptions,
      interpolation: {
        escapeValue: false
      }
    })
    .catch(Logger.error);
};

export default i18n;
